/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */


export const CLIENT_SECRET_TEXT = 'Here’s your Client Secret';
export const CLIENT_SECRET_PARAGRAPH = 'Your Client Secret has been generated. Copy it now, as it will not be shown again. For security, store it in a secure location and never share it publicly.';
export const SHOW_CLIENT_SECRET = 'Show Client Secret';
export const HIDE_CLIENT_SECRET = 'Hide Client Secret';
export const CLIENT_SECRET_COPY_SUCCESS_MESSAGE = 'Client Secret copied to clipboard';
export const COPY_TO_CLIPBOARD = 'Copy To Clipboard';
